import { render, staticRenderFns } from "./ImportantMessageAlert.vue?vue&type=template&id=7a4e4b42&scoped=true"
import script from "./ImportantMessageAlert.vue?vue&type=script&lang=js"
export * from "./ImportantMessageAlert.vue?vue&type=script&lang=js"
import style0 from "./ImportantMessageAlert.vue?vue&type=style&index=0&id=7a4e4b42&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e4b42",
  null
  
)

export default component.exports